import AccountGroup from "./AccountGroup.js";
import AccountGroupAliasing from "./AccountGroupAliasing.js";
import AccountListGroup from "./AccountListGroup.js";
import IntervalAccountGroup from "./IntervalAccountGroup.js";
import ModelFactory from "../ModelFactory.js";

/**
 * The receiver is responsible for materializing subclasses of
 * `abstractAccountGroup`.
 */
class AccountGroupFactory extends ModelFactory {
	allClasses() {
		return [
			AccountGroupAliasing,
			AccountGroup,
			AccountListGroup,
			IntervalAccountGroup,
		];
	}
}

const accountGroupFactory = new AccountGroupFactory();

export default accountGroupFactory;
